<template>
    <div class="index">

        <div class="white-color">

            <br class="no-move"/>

            <b-img class="img" src="../assets/Allgemein.png"></b-img>

            <br class="no-move"/>
            <br class="no-move"/>

            <h5 style="padding-top: 10px" class="no-move smaller-normal-text middle-wave text-dark gray-shadow">LabyHelp
                <strong class="red-dark-color">Group</strong></h5>

            <h1 class="display-title-strong text-dark container">
                Ist mehr als, <br/> ein LabyMod Addon.
            </h1>

            <p class="normal-text-secondary text-white-gray-color container">
                Wir bei LabyHelp versuchen Funktionen in LabyMod einzubauen
                die Spielern Möglichkeiten gibt, sich Sozial zu verknüpfen und schwierige Hürden einfacher zu
                überspringen.
            </p>

            <p style="color: #098c28" class="normal-text-secondary"><strong>Vielen Dank!</strong> Wähle nun deine
                gewünschte Minecraft (LabyMod) Version aus. <br class="no-move"/>Führe dann die installierte Datei mit
                einem Doppelklick aus.</p>
            <br class="no-move"/>

            <div class="container middle">

                    <b-button href="https://drive.google.com/u/0/uc?id=1_04KoR3sb9CEPQoxffezVsM_8V2G7q1s&export=download" size="lg" variant="success">1.8 & 1.12</b-button>
                    <p style="color: #4e4d4d" class="footnote-text">Mit dieser LabyHelp Version kannst du in der 1.8 und
                        1.12 spielen!</p>


                    <b-button href="https://drive.google.com/u/0/uc?id=1gMuWBW-_E5_Xzyh079d6XpcWxHuK8yff&export=download" size="lg" variant="success">1.16</b-button>
                    <p style="color: #4e4d4d" class="footnote-text">Mit dieser LabyHelp Version kannst du nur in der
                        1.16 spielen.
                    </p>
            </div>
        </div>

        <br class="no-move"/>
        <br class="no-move"/>


        <div class="black-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-strong purple-black-color">
                LabyHelp besteht aus mehreren Addons.
            </h1>

            <br class="no-move"/>
            <br class="no-move"/>

            <div class="container">

                <b-img class="img" src="../assets/LabyMatch.png"></b-img>

                <b-img class="img" src="../assets/LabyCreators300x300.png"></b-img>

                <br class="no-move"/>
                <br class="no-move"/>

                <p class="display-title-middle text-white">LabyMatch oder LabyCreators sind nur in der Kombination mit
                    LabyHelp
                    verfügbar. <strong>Viele Store Addons bieten mehr Features als manches andere LabyMod
                        Addon.</strong></p>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>


        </div>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="gold-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-middle text-dark">
                <strong>LabyHelp Store</strong>
            </h1>


            <h1 class="display-title-middle text-dark">

                Der LabyHelp Addon Store bietet jeden Nutzer weitere Zusatzfeatures und die Entscheidung diese Addons zu
                nutzen
                liegt allein bei dir!

            </h1>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <br class="no-move"/>
        <br class="no-move"/>


        <div class="container-small">
            <div class="green-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Bewirb deine Social Media.

                </h1>

                <p class="normal-text-title text-dark container">
                    Füge deinen <strong>Instagram, Discord, Twitch, TikTok, Twitter oder Youtube</strong> Namen hinzu
                    und lasse andere Spieler über das Interaktionsmenü oder über das LabyHelp Profil dein Account
                    folgen.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="container-small">
            <div class="yellow-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Kopiere Cosmetic Designs.

                </h1>

                <p class="normal-text-title text-dark container">
                    Du hast die Möglichkeit dir die <strong>Bandanas, Capes, Skins</strong> per Command oder durch das
                    Interaktionsmenü von anderen Spielern anzeigen oder herunterladen zu lassen.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="container-small">
            <div class="orange-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Setzte kreative Namen über dem Kopf.

                </h1>

                <p class="normal-text-title text-dark container">
                    Einen persönlichen und <strong>exklusiven oder spannenden Text</strong> unter deinem Namen. Der für
                    jeden LabyHelp Spieler sichtbar ist.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <h1 class="display-title-strong text-dark">

            LabyHelp bietet viele weitere Funktionen.

        </h1>

        <p class="display-title-middle text-dark container">Auf unserem <a
            href="https://www.youtube.com/channel/UCITHI08Diri9w4DS_2SZU8w">Youtube</a> oder <a
            href="https://instagram.com/labyhelp">Instagram</a> Kanal findest du spannende weitere Einblicke oder du
            Besuchst unseren <a href="https://labyhelp.de/discord">Discord Server</a> um keine neuen Updates mehr zu
            verpassen.</p>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="creppy-white-blass-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-strong text-white">

                Worauf wartest du?

            </h1>

            <p class="display-title-middle text-white container">
                Erlebe ab jetzt tolle Dinge mit dem LabyHelp Addon.
            </p>


            <b-button href="https://labyhelp.de/download" type="button" class="gray-shadow smaller-end-text"
                      variant="light">
                <fai :icon="['fas', 'download']" size="1x"/>
                <strong>Herunterladen</strong>
            </b-button>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="" style="alignment: bottom">
            <p class="smaller-end-text">© {{ today.getFullYear() }}
                <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                <a style="color: #6868b3" href="https://labyhelp.de/imprint">Imprint</a> -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/support">Support</a>
                -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/apply">Apply</a>
                -
                <a style="color: #6868b3"
                   target="_blank" href="https://stats.uptimerobot.com/ZrV89sM1jA">Status</a>
                -
                <a style="color: #6868b3"
                   href="ts3server://labyhelp.de">TeamSpeak</a>
            </p>
        </div>


    </div>
</template>


<script>
export default {
    name: "Download",
    data() {
        return {
            today: new Date()
        }
    },
}

</script>

<style scoped>

</style>
